import { createAction, props, createSelector, createReducer, on, select, Store, StoreModule } from '@ngrx/store';
import { InjectionToken, Injectable, Inject, ɵɵdefineInjectable, ɵɵinject, Pipe, Component, Renderer2, ViewChild, Input, NgModule } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { createEffect, ofType, Actions, EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { createEntityAdapter } from '@ngrx/entity';
import { map, mergeMap, retry, tap, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import Debug from 'debug';
import { NavigationEnd, Router } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/actions/localization.actions.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const getLocalizations = createAction('[Localization] getLocalizations');
/** @type {?} */
const onLocalizationsLoadedSuccessfully = createAction('[Localization] all localizations loaded successfully', props());
/** @type {?} */
const onLocalizationsLoadingFailed = createAction('[Localization] all localizations loading failed', props());
/** @type {?} */
const getLocalizationByKey = createAction('[Localization] getLocalizationByKey', props());
/** @type {?} */
const onLocalizationByKeyLoadedSuccessfully = createAction('[Localization] LocalizationByKey loaded successfully', props());
/** @type {?} */
const onLocalizationByKeyLoadingFailed = createAction('[Localization] LocalizationByKey loading failed', props());
/**
 * @record
 * @template T
 */
function ActionWithPayload() { }
if (false) {
    /** @type {?} */
    ActionWithPayload.prototype.payload;
}
/**
 * @record
 */
function ActionWithContentId() { }
if (false) {
    /** @type {?} */
    ActionWithContentId.prototype.key;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/localization.config.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ModesoLocalizationConfig() { }
if (false) {
    /** @type {?} */
    ModesoLocalizationConfig.prototype.serviceId;
}
/** @type {?} */
const ModesoLocalizationConfigService = new InjectionToken('Config');

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/localization.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function LocalizationResponse() { }
if (false) {
    /** @type {?} */
    LocalizationResponse.prototype.localizations;
}
/**
 * @record
 */
function LocalizationDetailResponse() { }
if (false) {
    /** @type {?} */
    LocalizationDetailResponse.prototype.localization;
}
class LocalizationService {
    /**
     * @param {?} http
     * @param {?} config
     */
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.server = '';
        this.microserviceName = 'localization';
        this.route = '/';
        this.detailRoute = ':id';
        this.cacheHeader = new HttpHeaders({
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
        });
        this.server = config.apiGateway;
    }
    /**
     * @return {?}
     */
    getLocalizations() {
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.route}`;
        return this.http.get(url, { headers: this.cacheHeader });
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getLocalizationByKey(key) {
        /** @type {?} */
        const keyId = this.detailRoute.replace(':id', key);
        /** @type {?} */
        const url = `${this.server}${this.microserviceName}${this.route}${keyId}`;
        return this.http.get(url, { headers: this.cacheHeader });
    }
}
LocalizationService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root',
            },] }
];
/** @nocollapse */
LocalizationService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: [ModesoLocalizationConfigService,] }] }
];
/** @nocollapse */ LocalizationService.ngInjectableDef = ɵɵdefineInjectable({ factory: function LocalizationService_Factory() { return new LocalizationService(ɵɵinject(HttpClient), ɵɵinject(ModesoLocalizationConfigService)); }, token: LocalizationService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    LocalizationService.prototype.server;
    /**
     * @type {?}
     * @private
     */
    LocalizationService.prototype.microserviceName;
    /**
     * @type {?}
     * @private
     */
    LocalizationService.prototype.route;
    /**
     * @type {?}
     * @private
     */
    LocalizationService.prototype.detailRoute;
    /**
     * @type {?}
     * @private
     */
    LocalizationService.prototype.cacheHeader;
    /**
     * @type {?}
     * @private
     */
    LocalizationService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    LocalizationService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/reducers/localization.reducer.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const featureKey = 'modesoLocalizationMicroservice';
// State Declarations - START
/** @type {?} */
const adapter = createEntityAdapter({
    selectId: selectContentId,
    sortComparer: sortById
});
/**
 * @param {?} a
 * @return {?}
 */
function selectContentId(a) {
    return a.key;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function sortById(a, b) {
    return a.key.localeCompare(b.key);
}
/**
 * @record
 */
function FeatureState() { }
/**
 * @record
 */
function AppState() { }
if (false) {
    /** @type {?} */
    AppState.prototype.modesoLocalizationMicroservice;
}
// State Declarations - END
// Selectors Declarations - START
/** @type {?} */
const selectFeature = (/**
 * @param {?} state
 * @return {?}
 */
(state) => state.modesoLocalizationMicroservice);
const ɵ0 = /**
 * @param {?} state
 * @return {?}
 */
(state) => state;
/** @type {?} */
const selectFeatureContent = createSelector(selectFeature, (ɵ0));
const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
/** @type {?} */
const selectLocalizationEntities = createSelector(selectFeatureContent, selectEntities);
/** @type {?} */
const selectContentAllEntities = createSelector(selectFeatureContent, selectAll);
const ɵ1 = /**
 * @param {?} entities
 * @param {?} props
 * @return {?}
 */
(entities, props) => {
    return entities[props.id];
};
/** @type {?} */
const selectEntitiesByID = createSelector(selectLocalizationEntities, (ɵ1));
// Selectors Declarations - END
// Reducer Declarations - START
/** @type {?} */
const initialState = adapter.getInitialState();
const ɵ2 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ3 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addMany(action.payload, Object.assign({}, state));
}, ɵ4 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ5 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state)), ɵ6 = /**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
(state, action) => {
    return adapter.addOne(action.payload, Object.assign({}, state));
}, ɵ7 = /**
 * @param {?} state
 * @return {?}
 */
state => (Object.assign({}, state));
/** @type {?} */
const contentReducer = createReducer(initialState, on(getLocalizations, (ɵ2)), on(onLocalizationsLoadedSuccessfully, (ɵ3)), on(onLocalizationsLoadingFailed, (ɵ4)), on(getLocalizationByKey, (ɵ5)), on(onLocalizationByKeyLoadedSuccessfully, (ɵ6)), on(onLocalizationByKeyLoadingFailed, (ɵ7)));
/**
 * @param {?} state
 * @param {?} action
 * @return {?}
 */
function reducer(state, action) {
    return contentReducer(state, action);
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/providers/localizationStore.provider.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug = Debug('modeso:modeso-localization:LocalizationStoreProvider');
class LocalizationStoreProvider {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        // Attention: this.loadLocalizations() cannot be called here, because the language is not known.
        // it must be called from the project using this microservice
        this.observers = new Set();
    }
    /**
     * @return {?}
     */
    loadLocalizations() {
        this.store.dispatch(getLocalizations());
    }
    // TODO add a method to access the store property by key, which generates an observable which can be used in a pipe
    // Is this the solution?
    /**
     * @param {?} key
     * @return {?}
     */
    getLocalizedStringForKey(key) {
        return this.store.pipe(select(selectEntitiesByID, { id: key }), map((/**
         * @param {?} localization
         * @return {?}
         */
        (localization) => {
            debug('got ' + key);
            debug(localization);
            if (localization) {
                debug('return ' + localization.text);
                return localization.text;
            }
            else {
                // TODO this must return the undefined
                // key in case we are in development mode.
                // TODO In production it should always
                // return "" if the key is not defined.
                // or return a default value if possible
                // return 'UNDEFINED KEY: ' + key;
                return undefined;
            }
        })));
    }
    /**
     * @param {?} namespace
     * @param {?} observer
     * @return {?}
     */
    addObserver(namespace, observer) {
        //TODO use the dependecy localization, if added
        debug('observer added to localization... ' + namespace);
        this.observers.add(observer);
        debug(this.observers.size);
    }
    /**
     * @param {?} localizations
     * @return {?}
     */
    notifyObservers(localizations) {
        debug('noify observers');
        debug(this.observers.size);
        this.observers.forEach((/**
         * @param {?} observer
         * @return {?}
         */
        observer => {
            observer.setInjectedText(localizations);
        }));
    }
}
LocalizationStoreProvider.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
LocalizationStoreProvider.ctorParameters = () => [
    { type: Store }
];
/** @nocollapse */ LocalizationStoreProvider.ngInjectableDef = ɵɵdefineInjectable({ factory: function LocalizationStoreProvider_Factory() { return new LocalizationStoreProvider(ɵɵinject(Store)); }, token: LocalizationStoreProvider, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    LocalizationStoreProvider.prototype.observers;
    /** @type {?} */
    LocalizationStoreProvider.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/effects/localization.effects.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$1 = Debug('modeso:modeso-localization:LocalizationEffects');
class LocalizationEffects {
    /**
     * @param {?} actions$
     * @param {?} service
     * @param {?} localizationStoreProvider
     */
    constructor(actions$, service, localizationStoreProvider) {
        this.actions$ = actions$;
        this.service = service;
        this.localizationStoreProvider = localizationStoreProvider;
        this.loadLocalizations$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getLocalizations.type), mergeMap((/**
         * @return {?}
         */
        () => {
            return this.service.getLocalizations()
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            (response) => {
                // send to dependecies
                this.localizationStoreProvider.notifyObservers(response.localizations);
            })), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onLocalizationsLoadedSuccessfully({ payload: response.localizations })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onLocalizationsLoadingFailed({ payload: error })))));
        })))));
        this.errorOnLoadLocalizations$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onLocalizationsLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadLocalizationsErrors(action.payload))))), { dispatch: false });
        this.loadLocalizationByKey$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(getLocalizationByKey.type), mergeMap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => {
            debug$1(`content should be loaded for ${action.key}`);
            return this.service.getLocalizationByKey(action.key)
                .pipe(retry(1), tap((/**
             * @param {?} response
             * @return {?}
             */
            (response) => this.log(response))), map((/**
             * @param {?} response
             * @return {?}
             */
            response => (onLocalizationByKeyLoadedSuccessfully({ payload: response.localization })))), catchError((/**
             * @param {?} error
             * @return {?}
             */
            (error) => of(onLocalizationByKeyLoadingFailed({ payload: error })))));
        })))));
        this.errorOnLoadLocalizationByKey$ = createEffect((/**
         * @return {?}
         */
        () => this.actions$.pipe(ofType(onLocalizationByKeyLoadingFailed.type), tap((/**
         * @param {?} action
         * @return {?}
         */
        (action) => this.handleOnLoadLocalizationsErrors(action.payload))))), { dispatch: false });
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleOnLoadLocalizationsErrors(error) {
        debug$1(error);
        return error;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    log(data) {
        debug$1(data);
    }
}
LocalizationEffects.decorators = [
    { type: Injectable }
];
/** @nocollapse */
LocalizationEffects.ctorParameters = () => [
    { type: Actions },
    { type: LocalizationService },
    { type: LocalizationStoreProvider }
];
if (false) {
    /** @type {?} */
    LocalizationEffects.prototype.loadLocalizations$;
    /** @type {?} */
    LocalizationEffects.prototype.errorOnLoadLocalizations$;
    /** @type {?} */
    LocalizationEffects.prototype.loadLocalizationByKey$;
    /** @type {?} */
    LocalizationEffects.prototype.errorOnLoadLocalizationByKey$;
    /**
     * @type {?}
     * @private
     */
    LocalizationEffects.prototype.actions$;
    /**
     * @type {?}
     * @private
     */
    LocalizationEffects.prototype.service;
    /**
     * @type {?}
     * @private
     */
    LocalizationEffects.prototype.localizationStoreProvider;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/pipes/localize.pipe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const debug$2 = Debug('modeso:modeso-localization:LocalizePipe');
class LocalizePipe {
    /**
     * @param {?} store
     */
    constructor(store) {
        this.store = store;
        debug$2('LocalizePipe constructed');
    }
    /**
     * @param {?} key
     * @return {?}
     */
    transform(key) {
        return this.store.pipe(select(selectEntitiesByID, { id: key }), map((/**
         * @param {?} localization
         * @return {?}
         */
        (localization) => {
            if (localization) {
                return localization.text;
            }
            else {
                // TODO this must return the undefined
                // key in case we are in development mode.
                // TODO In production it should always
                // return "" if the key is not defined.
                // or return a default value if possible
                // return 'UNDEFINED KEY: ' + key;
                return undefined;
            }
        })), filter((/**
         * @param {?} text
         * @return {?}
         */
        (text) => text !== undefined)));
    }
}
LocalizePipe.decorators = [
    { type: Pipe, args: [{ name: 'localize' },] }
];
/** @nocollapse */
LocalizePipe.ctorParameters = () => [
    { type: Store }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    LocalizePipe.prototype.store;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/components/language-switcher/languageSwitcher.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// TODO move to modeso-localization
class LanguageSwitcherComponent {
    /**
     * @param {?} router
     * @param {?} renderer
     */
    constructor(router, renderer) {
        this.router = router;
        this.renderer = renderer;
        this.navigationEnd$ = (/** @type {?} */ (router.events.pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        event => event instanceof NavigationEnd)))));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.constructNavigationItems();
        this.subscription = this.navigationEnd$.subscribe((/**
         * @param {?} evt
         * @return {?}
         */
        evt => {
            /** @type {?} */
            const activeLanguage = evt.url.split('/')[1];
            this.setRoutes(activeLanguage, evt.url);
        }));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.renderLangueageSwitcherLinks();
    }
    /**
     * @private
     * @return {?}
     */
    constructNavigationItems() {
        if (this.availableLanguages) {
            this.languages = new Map();
            this.availableLanguages.forEach((/**
             * @param {?} language
             * @return {?}
             */
            language => {
                /** @type {?} */
                const displayText = language.split('-')[0].toUpperCase();
                /** @type {?} */
                const text = this.renderer.createText(displayText);
                /** @type {?} */
                const a = this.renderer.createElement('a');
                this.renderer.appendChild(a, text);
                this.languages.set(language, a);
            }));
        }
    }
    /**
     * @private
     * @return {?}
     */
    renderLangueageSwitcherLinks() {
        if (this.availableLanguages) {
            this.availableLanguages.forEach((/**
             * @param {?} language
             * @return {?}
             */
            language => {
                /** @type {?} */
                const a = this.languages.get(language);
                /** @type {?} */
                const li = this.renderer.createElement('li');
                this.renderer.appendChild(li, a);
                this.renderer.appendChild(this.el.nativeElement, li);
            }));
        }
    }
    /**
     * @private
     * @param {?} activeLanguage
     * @param {?} route
     * @return {?}
     */
    setRoutes(activeLanguage, route) {
        if (this.availableLanguages) {
            this.availableLanguages.forEach((/**
             * @param {?} language
             * @return {?}
             */
            language => {
                /** @type {?} */
                const a = this.languages.get(language);
                this.renderer.setAttribute(a, 'href', route.replace(activeLanguage, language));
                if (activeLanguage === language) {
                    this.renderer.addClass(a, 'active');
                }
                else {
                    this.renderer.removeClass(a, 'active');
                }
            }));
        }
    }
}
LanguageSwitcherComponent.decorators = [
    { type: Component, args: [{
                selector: 'modeso-language-switcher',
                template: "<ul class=\"modeso-localization-languageSwitcher\" #languageSwitcher></ul>",
                styles: [".modeso-localization-languageSwitcher li{display:inline;border-right:1px solid #fff;line-height:30px}.modeso-localization-languageSwitcher li:last-child{border:0}.modeso-localization-languageSwitcher a{color:#fff;padding-right:.5rem;padding-left:.5rem;cursor:pointer;font-weight:300}.modeso-localization-languageSwitcher a.active{font-weight:700}"]
            }] }
];
/** @nocollapse */
LanguageSwitcherComponent.ctorParameters = () => [
    { type: Router },
    { type: Renderer2 }
];
LanguageSwitcherComponent.propDecorators = {
    el: [{ type: ViewChild, args: ['languageSwitcher', { static: false },] }],
    availableLanguages: [{ type: Input }]
};
if (false) {
    /**
     * @type {?}
     * @private
     */
    LanguageSwitcherComponent.prototype.languages;
    /**
     * @type {?}
     * @private
     */
    LanguageSwitcherComponent.prototype.subscription;
    /**
     * @type {?}
     * @private
     */
    LanguageSwitcherComponent.prototype.el;
    /** @type {?} */
    LanguageSwitcherComponent.prototype.availableLanguages;
    /**
     * @type {?}
     * @private
     */
    LanguageSwitcherComponent.prototype.navigationEnd$;
    /**
     * @type {?}
     * @private
     */
    LanguageSwitcherComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    LanguageSwitcherComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/localization.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ModesoLocalizationModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return {
            ngModule: ModesoLocalizationModule,
            providers: [
                LocalizationService,
                {
                    provide: ModesoLocalizationConfigService,
                    useValue: config
                }
            ]
        };
    }
}
ModesoLocalizationModule.decorators = [
    { type: NgModule, args: [{
                declarations: [LocalizePipe, LanguageSwitcherComponent],
                providers: [LocalizationService],
                imports: [
                    CommonModule,
                    StoreModule.forFeature(featureKey, reducer),
                    EffectsModule.forFeature([LocalizationEffects])
                ],
                exports: [LocalizePipe, LanguageSwitcherComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * Generated from: lib/models/localization.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class LocalizationModel {
    /**
     * @param {?} key
     * @param {?} text
     */
    constructor(key, text) {
        this.key = key;
        this.text = text;
    }
}
if (false) {
    /** @type {?} */
    LocalizationModel.prototype.key;
    /** @type {?} */
    LocalizationModel.prototype.text;
}

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: modeso-modeso-lib-localization-fe.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { LocalizationModel, LocalizationService, LocalizationStoreProvider, ModesoLocalizationConfigService, ModesoLocalizationModule, adapter, featureKey, getLocalizationByKey, getLocalizations, initialState, onLocalizationByKeyLoadedSuccessfully, onLocalizationByKeyLoadingFailed, onLocalizationsLoadedSuccessfully, onLocalizationsLoadingFailed, reducer, selectAll, selectContentAllEntities, selectContentId, selectEntities, selectEntitiesByID, selectFeature, selectFeatureContent, selectIds, selectLocalizationEntities, selectTotal, sortById, LocalizePipe as ɵa, LanguageSwitcherComponent as ɵb, LocalizationEffects as ɵc };
